import React from 'react'

const Aboutus = () => {
  return (
    <section className="about-area page-section scroll-to-page" id="about">
    <div className="custom-container">
      <div className="about-content content-width">
        <div className="section-header">
          <h4 className="subtitle scroll-animation" data-animation="fade_from_bottom">
            <i className="lar la-user" /> About
          </h4>
          <h1 className="scroll-animation" data-animation="fade_from_bottom">FullStack <span>Development</span></h1>
        </div>
        <p className="scroll-animation" data-animation="fade_from_bottom">Full-stack developer with one year of hands-on experience and a passion for creating efficient and user-friendly design and featured. I've successfully completed two projects and currently working on third project, showcasing my proficiency in both front-end and back-end development. I mostly Working in React.js and I also Worked With PHP API,PYTHON API,NODE.JS API and JAVA API. I'm eager to contribute my skills and grow with a dynamic team. Let's build something amazing together!</p>
        <h4 className="subtitle scroll-animation theme-btn" data-animation="fade_from_bottom">
            <i className="las la-briefcase" /> Download CV
          </h4>
      </div>
    </div>
  </section>
  )
}

export default Aboutus